var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsite2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#219653"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.875C9.51289 5.875 5.875 9.51289 5.875 14C5.875 18.4871 9.51289 22.125 14 22.125C18.4871 22.125 22.125 18.4871 22.125 14C22.125 9.51289 18.4871 5.875 14 5.875Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.875C11.7316 5.875 9.59883 9.51289 9.59883 14C9.59883 18.4871 11.7316 22.125 14 22.125C16.2684 22.125 18.4012 18.4871 18.4012 14C18.4012 9.51289 16.2684 5.875 14 5.875Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58321 8.58325C10.077 9.6438 11.9574 10.2762 14 10.2762C16.0426 10.2762 17.9231 9.6438 19.4168 8.58325M19.4168 19.4168C17.9231 18.3563 16.0426 17.7239 14 17.7239C11.9574 17.7239 10.077 18.3563 8.58321 19.4168",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.875V22.125M22.125 14H5.875",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite2);
export default __webpack_public_path__ + "static/media/website-2.38b39129b2362aa083ddd5038073dee8.svg";
export { ForwardRef as ReactComponent };